import { render, staticRenderFns } from "./AssistRequestContent.vue?vue&type=template&id=386df186&scoped=true"
import script from "./AssistRequestContent.vue?vue&type=script&lang=ts"
export * from "./AssistRequestContent.vue?vue&type=script&lang=ts"
import style0 from "./AssistRequestContent.vue?vue&type=style&index=0&id=386df186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386df186",
  null
  
)

export default component.exports